import React from 'react';

import DesktopNavActions from './desktop/DesktopNavActions';
import DesktopNavItem from './desktop/DesktopNavItem';
import MobileNav from './mobile/MobileNav';
import TabletNavActions from './tablet/TabletNavActions';
import type {
  DesktopNavConfig,
  MobileNavConfig,
  TabletNavConfig,
} from './types';

interface TopNavigationBarProps {
  desktop: DesktopNavConfig;
  tablet: TabletNavConfig;
  mobile: MobileNavConfig;
  logoUrl: string;
}

export default function TopNavigationBar({
  desktop,
  tablet,
  mobile,
  logoUrl,
}: TopNavigationBarProps): JSX.Element {
  return (
    <nav className="sticky top-0 z-50 w-full border-b border-gray-200 bg-white p-4 topnav-xl:px-6 topnav-xl:py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-5">
          <a href="/" className="flex-shrink-0">
            <img src={logoUrl} alt="Storyblocks" width={151} height={32} />
          </a>
          {/* Tablet inline items (lg to xl) */}
          <div className="hidden items-center lg:flex topnav-xl:hidden">
            {tablet.navItems.map((item) => (
              <DesktopNavItem key={item.id} config={item} />
            ))}
          </div>
          {/* Desktop inline items (xl+) */}
          <div className="hidden items-center topnav-xl:flex">
            {desktop.navItems.map((item) => (
              <DesktopNavItem key={item.id} config={item} />
            ))}
          </div>
        </div>

        <div className="flex items-center gap-4">
          <DesktopNavActions items={desktop.actions} />
          <TabletNavActions config={tablet} logoUrl={logoUrl} />
          <MobileNav config={mobile} logoUrl={logoUrl} />
        </div>
      </div>
    </nav>
  );
}
